import Icon from '../components/Icon.vue'

Icon.register({
  plug: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M256 144v-112c0-17.7 14.3-32 32-32s32 14.3 32 32v112h-64zM368 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-16v32c0 77.4-55 142-128 156.8v99.2h-64v-99.2c-73-14.8-128-79.4-128-156.8v-32h-16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h352zM128 144h-64v-112c0-17.7 14.3-32 32-32s32 14.3 32 32v112z'
      }
    ]
  }
})
